import { render } from "./Dna.vue?vue&type=template&id=673ef8e9&scoped=true"
import script from "./Dna.vue?vue&type=script&lang=js"
export * from "./Dna.vue?vue&type=script&lang=js"

import "./Dna.vue?vue&type=style&index=0&id=673ef8e9&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673ef8e9"]])

export default __exports__